var _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemperatureIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.613,
    height: 5.53,
    viewBox: "0 0 39.613 5.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#f76868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#ffb300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#00d98a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#00fb97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f9"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.613,
    height: 5.53,
    rx: 2.765,
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIndicator);
export default __webpack_public_path__ + "static/media/temperatureIndicator.564a81726b5f69df4150ee24bc73a892.svg";
export { ForwardRef as ReactComponent };